import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthTokenService } from '../services/auth-token.service';
import { SessionService } from '../services/session.service';


export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class AuthGuard implements CanActivate, CanDeactivate<CanComponentDeactivate> {

  constructor(private router: Router, private authTokenService: AuthTokenService, private session: SessionService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let token = this.authTokenService.getToken();
    
   
    if (token) {
      //console.log("token", token)
      return this.session.sessionEvent$.asObservable().pipe(map(user => {
        if (user.userAuthenticate == true) {
          //console.log(user.userAuthenticate)
          if (route.url.length > 0 && route.url[0].path == 'login') {
            this.router.navigate(['']);
            return false;
          }
          else {

            return true;
          }
        }
        else {
          if (route.url.length > 0 && route.url[0].path == 'login') {
            return true;
          }
          else {
            this.router.navigate(['login']);
            return false;
          }
        }
      }));
    }
    else {
      if (route.url.length > 0 && route.url[0].path == 'login') {

        return true;
      }
      else {

        this.router.navigate(['login']);
        return false;
      }
    }
  }

  canDeactivate(component: CanComponentDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return component.canDeactivate(); //the function will be called on the component, that's why we'll implement the function on the component.
  }

}
